import { combineReducers } from 'redux';
// import * as TYPES from './Root.actionTypes.js';
import { firebaseReducer } from 'react-redux-firebase'
import { firestoreReducer } from 'redux-firestore';
import { views } from '../redux/Redux.reducer.js';

// import { otherReducers } from 'places';

const appReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  views,
});

export const rootReducer = (state = undefined, action) => {
  // if (action && action.type === TYPES.RESET_STORE) {
  //   state = undefined;
  // }
  return appReducer;
};
